import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "src/app/core/service/app.service";
import { AuthService } from "src/app/core/service/auth.service";
import { DoctorService } from "src/app/doctor/doctor.service";
import PharmcistService from "src/app/pharmacist/pharmcist.service";
import { Constants } from "../../models/constants";
import { Country } from "../../models/country";
import { DoctorDetails } from "../../models/doctorDetails";
import { Qualification } from "../../models/qualification";
import { Specialization } from "../../models/specialization";
import { State } from "../../models/state";
import { UserAccount } from "../../models/user-account";
import { NotificationService } from "../../notification.service";
import { userRole } from "../../userRole";
import { ProfileComponent } from "../profile.component";
import { ViewProfileComponent } from "../view-profile/view-profile.component";
import { Location } from "@angular/common";
import { CollectionlocationsModel } from "../../models/collectionlocations";
import { stringify } from "querystring";

@Component({
  selector: "app-edit-profile",
  templateUrl: "./edit-profile.component.html",
  styleUrls: ["./edit-profile.component.sass"],
})
export class EditProfileComponent extends ViewProfileComponent {
  docForm: FormGroup;
  userAccount: UserAccount;
  imgSrc: SafeUrl;
  qualifications: Qualification[];
  specializations: Specialization[];
  fileObj: any;
  newDoctorDetails: DoctorDetails;
  countryList: Country[];
  stateList: State[];
  split_Qualification: any[];
  split_Specializations: any[];
  constants: any;
  emailPattern: any;
  bind_Qualifications: Qualification[];
  bind_Specialization: Specialization[];
  maxDate = new Date();
  collectionLocation: any=[];
  isSearch:boolean = false;
  collectionlocationsmodel: CollectionlocationsModel;
  collectionLocationkey: any;
  locationItem:any=[]; 
  locationcount:any; 
  constructor(
    private _fb: FormBuilder,
    private _authService: AuthService,
    public doctorService: DoctorService,
    public spinner: NgxSpinnerService,
    public appService: AppService,
    public sanitizer: DomSanitizer,
    public datePipe: DatePipe,
    public router: Router,
    public dialog: MatDialog,
    public pharmacistService: PharmcistService,
    public notificationService: NotificationService,
    public location: Location
  ) {
    super(
      _fb,
      _authService,
      doctorService,
      spinner,
      appService,
      sanitizer,
      router,
      dialog,
      pharmacistService,
      notificationService,
      location
    );
    this.userAccount = new UserAccount();
    this.constants = Constants;
    this.emailPattern = this.constants.EMAIL_REGEXP;
    this.userAccount = this.currentUser;
    this.collectionlocationsmodel = new CollectionlocationsModel();
    this.fileObj = null;
    this.bind_Specialization = new Array<Specialization>();
    this.bind_Qualifications = new Array<Qualification>();
  }

  ngOnInit() {
    if (this.currentUser.UserRoleId == userRole.doctor) {
      this.createContactForm();
      this.getQualification();
    } else {
      this.createContactForm();
      this.getCollectionLocation();
    }
    this.getCountries();
   
  }

  createContactForm() {
    // var splitting_array = this.doctorDetails.doctor.Qualification.split(",");
    // var split_objects = splitting_array.map(function (str) {
    //   var box = str.split(",");
    //   return {
    //     Name: box[0],
    //     Id: 1,
    //     IsActive: 1,
    //     CreatedById: 1,
    //     CreatedDate: "2021-06-15T07:18:11",
    //   };
    // });
    this.docForm = this._fb.group({
      picture: [""],
      firstname: [
        this.userAccount.FirstName,
        [Validators.required, Validators.pattern(this.constants.NAME_REGEXP)],
      ],
      lastname: [
        this.userAccount.LastName,
        [Validators.required, Validators.pattern(this.constants.NAME_REGEXP)],
      ],
      gender: [
        this.userAccount.Gender != null
          ? this.userAccount.Gender == "M"
            ? "M"
            : "F"
          : null,
      ],
      qualification: [
        this.doctorDetails.doctor.Qualification != null &&
        this.doctorDetails.doctor.Qualification != ""
          ? this.doctorDetails.doctor.Qualification.split(",")
          : [],
        Validators.required,
      ],
      registrationnumber: [
        this.doctorDetails.doctor.RegistrationNumber,
        [Validators.required],
      ],

      specialization: [
        // this.doctorDetails.doctor.Specialization != null &&
        // this.doctorDetails.doctor.Specialization != ""
        //   ? this.doctorDetails.doctor.Specialization.split(",")
        //   : [],
        // Validators.required,
      ],

      // regcertificate: ["", Validators.required],
      phone: [
        this.userAccount.Phone,
        [
          Validators.required,
          Validators.nullValidator,
          Validators.maxLength(10),
        ],
      ],
      password: [],
      conformPassword: [],
      email: [
        this.userAccount.Email,
        [Validators.required, Validators.email, Validators.minLength(5)],
      ],
      addreslineone: [this.userAccount.AddressLine1],
      addreslinetwo: [this.userAccount.AddressLine2],
      dob: [
        (this.userAccount.DateOfBirth = this.userAccount.DateOfBirth !== null ? new Date(this.userAccount.DateOfBirth) : null),
      ],
      practicename: [
        this.doctorDetails.doctor.PracticeName,
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern(this.constants.NAME_REGEXP),
        ],
      ],
      officecontactname: [
        this.doctorDetails.doctor.OfficeContactName,
        // [
        //   Validators.required,
        //   Validators.maxLength(20),
        //   Validators.pattern(this.constants.NAME_REGEXP),
        // ],
      ],
      city: [
        this.userAccount.City,
        [
          Validators.pattern(this.constants.NAME_REGEXP),
          Validators.minLength(2),
        ],
      ],
      aboutme: [this.doctorDetails.doctor.AboutMe],
      state: [this.userAccount.State],
      zip: [this.userAccount.Zip, [Validators.maxLength(10)]],
      country: [this.userAccount.Country],
      collectionlocation: [this.collectionlocationsmodel.Collectionlocations]
      // collectionlocations: ["", [Validators.pattern(this.constants.NAME_REGEXP)]]
    });

    if (this.currentUser.UserRoleId != 2) {
      this.docForm.removeControl("qualification");
      this.docForm.removeControl("specialization");
      this.docForm.removeControl("practicename");
      this.docForm.removeControl("officecontactname");
      this.docForm.removeControl("aboutme");
      this.docForm.removeControl("regcertificate");
      this.docForm.removeControl("registrationnumber");
    }
  }

  getCurrentUserDetails() {
    const user = { Id: this.currentUser.Id };
    this.spinner.show();
    this.appService.getUser(user).subscribe({
      next: (res) => {
        if (!res.HasErrors) {
          res.DateOfBirth =
            res.DateOfBirth !== null ? new Date(res.DateOfBirth) : null;
          this.userAccount =
            res !== undefined && res !== null ? res : new UserAccount();
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  UpdateUserDetails() {
    if (this.docForm.valid) {
      if (this.currentUser.UserRoleId == userRole.doctor) {
        this.UpdateDoctor();
      } else if (
        this.currentUser.UserRoleId == userRole.pharmacist ||
        this.currentUser.UserRoleId == userRole.pharmacistSubAdmin
      ) {
        this.UpdatePharmacist();
      }
    }
  }

  UpdateDoctor() {
    this.doctorDetails.doctor.Specialization = this.docForm.get(
      "specialization"
    ).value;
    this.doctorDetails.doctor.Qualification = this.docForm.get(
      "qualification"
    ).value;
    // if (true) {
    this.spinner.show();
    let specializeString = null;
    if (this.docForm.get("specialization").value?.length > 0) {
      for (
        let index = 0;
        index < this.doctorDetails.doctor.Specialization?.length;
        index++
      ) {
        if (specializeString == null) {
          specializeString = this.doctorDetails.doctor.Specialization[index]
            ?.Name;
        } else {
          specializeString =
            specializeString +
            "," +
            this.doctorDetails.doctor.Specialization[index]?.Name;
        }
      }
      this.doctorDetails.doctor.Specialization = specializeString;
    }

    let qualificationString = null;
    if (this.doctorDetails.doctor.Qualification?.length > 0) {
      for (
        let index = 0;
        index < this.doctorDetails.doctor.Qualification?.length;
        index++
      ) {
        if (qualificationString == null) {
          qualificationString = this.doctorDetails.doctor.Qualification[index]
            ?.Name;
        } else {
          qualificationString =
            qualificationString +
            "," +
            this.doctorDetails.doctor.Qualification[index]?.Name;
        }
      }
      this.doctorDetails.doctor.Qualification = qualificationString;
      this.doctorDetails.doctor.PracticeName = this.docForm.get(
        "practicename"
      ).value;
      this.doctorDetails.doctor.RegistrationNumber = this.docForm.get(
        "registrationnumber"
      ).value;
      this.doctorDetails.doctor.OfficeContactName = this.docForm.get(
        "officecontactname"
      ).value;
      this.doctorDetails.doctor.AboutMe = this.docForm.get("aboutme").value;
      this.userAccount.DateOfBirth = this.docForm.get("dob").value;
      this.userAccount.FirstName = this.docForm.get("firstname").value;
      this.userAccount.LastName = this.docForm.get("lastname").value;
      this.userAccount.AddressLine1 = this.docForm.get("addreslineone").value;
      this.userAccount.AddressLine2 = this.docForm.get("addreslinetwo").value;
      this.userAccount.Country = this.docForm.get("country").value;
      this.userAccount.State = this.docForm.get("state").value;
      this.userAccount.City = this.docForm.get("city").value;
      this.userAccount.Gender = this.docForm.get("gender").value;
      this.userAccount.Zip = this.docForm.get("zip").value;
      this.userAccount.Phone = this.docForm.get("phone").value;
      this.userAccount.CreatedById = this.currentUser.Id;
      this.userAccount.ModifiedById = this.currentUser.Id;
      this.collectionlocationsmodel.Collectionlocations = this.docForm?.get("collectionlocations")?.value;
      var accountDetails = {
        UserRole: "DC",
        UserDetails: this.userAccount,
        DoctorDetails: this.doctorDetails.doctor,
        FilesProfile: this.fileObj,
      };
      // if (this.docForm.get("dob").value != null) {
      //   this.docForm.controls.dob.setValue(
      //     this.datePipe.transform(this.docForm.controls.dob.value, "MM/dd/yyyy")
      //   );
      // }

      
      if (this.docForm.controls.dob.value != null) {
        var dob = this.docForm.controls.dob.value;
        dob = this.datePipe.transform(dob, "MM/dd/yyyy");
        this.userAccount.DateOfBirth = dob;
      }
      this.appService.AccountUpdate(accountDetails).subscribe({
        next: (res: any) => {
          if (!res.HasErrors) {
            res.DateOfBirth =
              res.DateOfBirth !== null ? new Date(res.DateOfBirth) : null;
            this.currentUser =
              res !== undefined && res !== null ? res : new UserAccount();
            if (sessionStorage.getItem("CurrentUser") != null) {
              sessionStorage.removeItem("CurrentUser");
              sessionStorage.setItem(
                "CurrentUser",
                JSON.stringify(this.currentUser)
              );
            }
            if (localStorage.getItem("CurrentUser") != null) {
              localStorage.removeItem("CurrentUser");
              localStorage.setItem(
                "CurrentUser",
                JSON.stringify(this.currentUser)
              );
            }
            this.appService.userDetails.next(this.currentUser);
            this._authService.showNotification(
              "snackbar-success",
              "Profile updated successfully.",
              "top",
              "center"
            );
            // this.goBack();
            this.router.navigateByUrl("/doctor/profile/view");
            this.spinner.hide();
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
    }
  }

  UpdatePharmacist() {
    var counter = 1
    var newcolla = this.collectionLocation
    // var newcolla = this.docForm.get("collectionlocations").value;

    // var newLocationObj={};
    //  newcolla.forEach(element => {
    //   newLocationObj["location"+counter]=element
    //   // 'location'+counter +':'+ element
    //   // this.locationItem.push(this.locationcount)
    //   counter++;
      
    //  });
    this.spinner.show();
     this.collectionlocationsmodel.Collectionlocations =  this.locationItem;

    this.userAccount.DateOfBirth = this.docForm.get("dob").value;
    this.userAccount.FirstName = this.docForm.get("firstname").value;
    this.userAccount.LastName = this.docForm.get("lastname").value;
    this.userAccount.AddressLine1 = this.docForm.get("addreslineone").value;
    this.userAccount.AddressLine2 = this.docForm.get("addreslinetwo").value;
    this.userAccount.Country = this.docForm.get("country").value;
    this.userAccount.State = this.docForm.get("state").value;
    this.userAccount.City = this.docForm.get("city").value;
    this.userAccount.Gender = this.docForm.get("gender").value;
    this.userAccount.Zip = this.docForm.get("zip").value;
    this.userAccount.Phone = this.docForm.get("phone").value;
    
    // this.collectionlocationsmodel.Collectionlocations = this.docForm.get("collectionlocations").value;
    this.userAccount.CreatedById = this.currentUser.Id;
    this.userAccount.ModifiedById = this.currentUser.Id;
 
    var accountDetails = {
      UserRole: this.userAccount.UserRoleId == 3 ? "PAD" : "PSAD",
      UserDetails: this.userAccount,
      DoctorDetails: null,
      // FilesMetadata: this.fileObj,
      FilesProfile: this.fileObj,
      CollectionLocation:{}
    };
    newcolla.forEach(element => {
      accountDetails.CollectionLocation["location"+counter]=element
      // 'location'+counter +':'+ element
      // this.locationItem.push(this.locationcount)
      counter++;
      
     });

    if (this.docForm.controls.dob.value != null) {
      var dob = this.docForm.controls.dob.value;
      dob = this.datePipe.transform(dob, "MM/dd/yyyy");
      this.userAccount.DateOfBirth = dob;
    }
    this.appService.AccountUpdate(accountDetails).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          resp.DateOfBirth =
            resp.DateOfBirth !== null ? new Date(resp.DateOfBirth) : null;
          this.currentUser =
            resp !== undefined && resp !== null ? resp : new UserAccount();
          if (sessionStorage.getItem("CurrentUser") != null) {
            sessionStorage.removeItem("CurrentUser");
            sessionStorage.setItem(
              "CurrentUser",
              JSON.stringify(this.currentUser)
            );
          }
          if (localStorage.getItem("CurrentUser") != null) {
            localStorage.removeItem("CurrentUser");
            localStorage.setItem(
              "CurrentUser",
              JSON.stringify(this.currentUser)
            );
          }
          this.appService.userDetails.next(this.currentUser);
          this._authService.showNotification(
            "snackbar-success",
            "Profile updated successfully.",
            "top",
            "center"
          );
          this.router.navigateByUrl("/doctor/profile/view");
          // this.goBack();
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  getProfilePicture(documentId) {
    const doc = { DocumentId: documentId };
    this.appService.getProfilePicture(doc).subscribe((res: any) => {
      if (!res.HasErrors) {
        this.dmsDocument = Object.assign({}, res);
        if (this.dmsDocument.Base64Url) {
          this.imgSrc = this.getSantizeUrl(this.dmsDocument.Base64Url);
          this.imgSrc !== 0 ? this.imgSrc : "./assets/images/default-user.png";
        }
      }
    });
  }

  public getSantizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  GetDoctorDetails() {
    var doctorDetails = {
      doctorAccountId: this.currentUser.Id,
    };
    this.spinner.show();
    this.doctorService.GetDoctorDetailsById(doctorDetails).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.doctorDetails = resp;
          this.split_Qualification = this.doctorDetails.doctor.Qualification.split(
            ","
          );
          this.split_Specializations = this.doctorDetails.doctor.Specialization.split(
            ","
          );
          // this.split_objects = this.doctorDetails.doctor.Qualification.map(
          //   function (str) {
          //     var box = str.split(",");
          //     return { Name: box[0] };
          //   }
          // );

          this.qualifications.forEach((element: Qualification) => {
            for (
              let index = 0;
              index < this.split_Qualification.length;
              index++
            ) {
              if (element.Name == this.split_Qualification[index]) {
                this.bind_Qualifications.push(element);
              }
            }
          });

          this.docForm.get("qualification").setValue(this.bind_Qualifications);

          this.specializations.forEach((element: Specialization) => {
            for (
              let index = 0;
              index < this.split_Specializations.length;
              index++
            ) {
              if (element.Name == this.split_Specializations[index]) {
                this.bind_Specialization.push(element);
              }
            }
          });
          this.docForm.get("specialization").setValue(this.bind_Specialization);
          this.docForm
            .get("registrationnumber")
            .setValue(this.doctorDetails.doctor.RegistrationNumber);
          this.docForm
            .get("practicename")
            .setValue(this.doctorDetails.doctor.PracticeName);
          this.docForm
            .get("officecontactname")
            .setValue(this.doctorDetails.doctor.OfficeContactName);
          this.userAccount = resp?.userAccount;

          if (
            this.docForm.get("registrationnumber").value != null &&
            this.docForm.get("registrationnumber").value != ""
          ) {
            this.docForm.get("registrationnumber").disable();
          }
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }
  getQualification() {
    this.spinner.show();
    this.appService.getQualification().subscribe((res) => {
      if (!res.HasErrors) {
        if (res.Rows.length !== 0) {
          this.qualifications =
            res.Rows.length !== 0 ? res.Rows : new Array<Qualification>();
          this.getSpecialization();
        } else {
          this.spinner.hide();
        }
      }
    });
  }

  getSpecialization() {
    this.appService.getSpecialization().subscribe((res) => {
      if (!res.HasErrors) {
        if (res.Rows.length !== 0) {
          this.specializations =
            res.Rows.length !== 0 ? res.Rows : new Array<Specialization>();
          this.GetDoctorDetails();
        } else {
          this.spinner.hide();
        }
      }
    });
  }

  uploadProfile(evt) {
    if (evt.target.files.length !== 0) {
      const files = evt.target.files;
      const file = files[0];
      const reader = new FileReader();
      if (files && file) {
        reader.onload = this._handleReaderLoadeds2.bind(this, file);
        reader.readAsArrayBuffer(file);
      }
    }
  }

  _handleReaderLoadeds2(file, readerEvt) {
    this.spinner.show();
    if (
      file.type === "image/png" ||
      file.type === "image/jpeg" ||
      file.type === "image/jpg"
    ) {
      if (file.size < 5051341) {
        const buffer = readerEvt.target.result;
        const base64file = this.arrayBufferToBase64(buffer);
        const fileObj = {
          FileName: file.name,
          File: base64file,
          DocumentType: file.type,
          status: "1",
        };
        this.fileObj = fileObj;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this._authService.showNotification(
          "snackbar-danger",
          "File too Big, please select a file less than 5mb",
          "top",
          "center"
        );
        this.docForm.controls.picture.setValue(null);
      }
    } else {
      this.spinner.hide();
      this._authService.showNotification(
        "snackbar-danger",
        "The filetype you are attempting to upload is not allowed.",
        "top",
        "center"
      );
      this.docForm.controls.picture.setValue(null);
    }
  }

  arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  onSubmit() {
  }

  getCountries() {
    this.spinner.show();
    this.appService.getCountries().subscribe({
      next: (res) => {
        if (!res.HasErrors) {
          this.countryList =
            res.Rows.length !== 0 ? res.Rows : new Array<Country>();
          this.getStatesByCountry();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  getStatesByCountry() {
    this.appService.getStates().subscribe({
      next: (res) => {
        if (!res.HasErrors) {
          this.stateList =
            res.Rows !== null && res.Rows !== undefined && res.Rows.length !== 0
              ? res.Rows
              : new Array<State>();
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  getCollectionLocation() {
    const doc = 
    { 
      collectionLocation: 
      {
        userAccountId: this.currentUser.Id
      }
    };
    this.appService.getCollectionlocations(doc).subscribe((res: any) => {
      if (!res.HasErrors) {
        if(res.CollectionLocation!=null)
        {
          this.collectionLocation = res.CollectionLocation;
          // var newtag = this.collectionLocation.replace('\r\n',"");
          this.collectionLocation = JSON.parse(this.collectionLocation)
          this.collectionLocation = Object?.values(this.collectionLocation)
          this.collectionLocationkey = Object.keys(JSON.parse(res.CollectionLocation))
        }
      }
    });
  }



  enterCollectionLocation(tags:any,forSearch:boolean) {
    if(tags.searchTerm.length!=0)
    {
    this.collectionLocation
    if(!forSearch)
    {
      if(this.collectionLocation && this.collectionLocation?.length!=0 )
      {
        for (let members of this.collectionLocation) {
          if (members != tags.searchTerm) {
            this.collectionLocation = [...this.collectionLocation, tags.searchTerm]
            tags.searchTerm='';
            return
          }
        }
      }
      else
      {
        this.collectionLocation = tags.searchTerm
        for (let members of this.collectionLocation) {
          if (members != tags.searchTerm) {
            this.collectionLocation = [tags.searchTerm];
            tags.searchTerm='';
            return
          }
        }
        return
      }
    } 
  }
  }

  ValidateTags(evt: any) {
    var keyCode = evt.keyCode;
    if (
      (keyCode >= 65 && keyCode <= 90) ||
      (keyCode >= 97 && keyCode <= 122) ||
      (keyCode >= 48 && keyCode <= 57)
    ) {
      return true;
    } else {
      return false;
    }
  }
  clearTags(){
    this.docForm.value.Tags.setValue('');
  }

  onRemove(tags:any,event:any)
  {
    if(event.value)
    {
    this.collectionLocation
      if(this.collectionLocation?.length!=0)
      {
        for (let members of this.collectionLocation) {
          if (members == event.value) {
            this.collectionLocation.pop(event.value);
            this.collectionLocation = [...this.collectionLocation]
            return
          }
        }
      }
      else
      {
        this.collectionLocation = tags.searchTerm
        for (let members of this.collectionLocation) {
          if (members != tags.searchTerm) {
            this.collectionLocation = [...this.collectionLocation, tags.searchTerm]
            return
          }
        }
        return
      }
  }
  }

}
